import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwsomeSwiper from 'vue-awesome-swiper'
import iView from 'iview'
import store from './store/index'
import 'iview/dist/styles/iview.css'
// import 'swiper/dist/css/swiper.css'
import VueClipboard from 'vue-clipboard2'
import "babel-polyfill"
import MetaInfo from 'vue-meta-info'
// import VueParticles from 'vue-particles'

import { Swipe, SwipeItem } from 'vue-swipe'
Vue.component('swipe', Swipe)
Vue.component('swipe-item', SwipeItem)

require('../src/assets/styles/reset.css')
require('../src/assets/styles/border.css')
require('../src/assets/styles/iconfont.css')
require("../src/assets/styles/restore.css")
require("../src/assets/styles/iconfont.js")

Vue.use(iView)
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.use(VueAwsomeSwiper)
Vue.use(MetaInfo)
// Vue.use(VueParticles)
Vue.config.devtools = true;
if ( !Array.prototype.forEach ) {
  Array.prototype.forEach = function forEach( callback, thisArg ) {

    var T, k;

    if ( this == null ) {
      throw new TypeError( "this is null or not defined" );
    }
    var O = Object(this);
    var len = O.length >>> 0;
    if ( typeof callback !== "function" ) {
      throw new TypeError( callback + " is not a function" );
    }
    if ( arguments.length > 1 ) {
      T = thisArg;
    }
    k = 0;

    while( k < len ) {

      var kValue;
      if ( k in O ) {

        kValue = O[ k ];
        callback.call( T, kValue, k, O );
      }
      k++;
    }
  };
}

/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
})

// history.pushState(null, null, document.URL);
// window.addEventListener('popstate', function () {
// 	history.pushState(null, null, document.URL);
// });


function getDomainQuery(url) {
	var d = [];
	var st = url.indexOf('//', 1);
	var _domain = url.substring(st + 1, url.length);
	var et = _domain.indexOf('/', 1);
	d.push(_domain.substring(1, et));
	d.push(_domain.substring(et + 1, url.length));
	return d
}

function route() {
	var eg = [];
	eg.push(['baidu', 'wd']);
	eg.push(['google', 'q']);
	eg.push(['soso', 'w']);
	eg.push(['yodao', 'q']);
	eg.push(['bing', 'q']);
	eg.push(['yahoo', 'q']);
	eg.push(['sogou', 'query']);
	eg.push(['gougou', 'search']);
	eg.push(['360', 'q']);

	var dq = getDomainQuery(document.referrer);

	var keyword=null;
	var grep=null;
	var str=null;

	for(var el in eg){
		var s = eg[el];
		var DandQ=String(s).split(","); //字符分割
		if (dq[0].indexOf(DandQ[0])>0){
			eval("grep=/"+DandQ[1]+"\=.*\&/i;");
			str = dq[1].match(grep);
			keyword = str.toString().split("=")[1].split("&")[0];
			keyword = decodeURIComponent(keyword);
			console.log(keyword);
			return false;
		}
	}

}
route()



// WEBPACK FOOTER //
// ./src/main.js